<app-loading *ngIf="this.get_api_result.Posting" type="LOADING_DATA"></app-loading>
<div class="ui-g" *ngIf="this.get_api_result.PromiseResult.success">
    <div class="ui-g-12">

        <div class="card-box composecard">
            <form #feedBackForm="ngForm" accept-charset="UTF-8" (ngSubmit)="SaveData($event)">
                <div class="ui-g">
                    <div class="ui-g-12">
                        <span class="section-heading ">Did patient join the consultation?
                        </span>
                    </div>
                    <div class="ui-md-8">
                        <span class="doctorfradio">
                            <p-radioButton name="pjoin1" label="Yes" [value]="true"
                                [(ngModel)]="sendFeedBackData.patient_joined" required>
                            </p-radioButton>
                        </span>
                        <span class="doctorfradio">
                            <p-radioButton name="pjoin2" label="No" [value]="false"
                                [(ngModel)]="sendFeedBackData.patient_joined" required>
                            </p-radioButton>
                        </span>
                    </div>
                </div>
                <div *ngIf="sendFeedBackData.patient_joined==true">
                    <div class="ui-g">
                        <div class="ui-g form-group">
                            <label class="boldnlabel">History Of Current Illness*</label>
                            <div class="ui-g-12">

                                <textarea class="format-lines msgtxtarea" pInputTextarea placeholder="Type here"
                                    [(ngModel)]="this.sendFeedBackData.history_of_current_illness" name="hci"
                                    #hci="ngModel" [required]="!isSuperAdmin()"></textarea>

                                <div style="text-align: center;">
                                    <p [style.color]="this.sendFeedBackData.history_of_current_illness.length-max_message_length_hci-1>0?'red':'green'"
                                        style="text-align: center;">
                                        {{(max_message_length_hci+1-this.sendFeedBackData.history_of_current_illness.length)
                                        <0?0:max_message_length_hci-this.sendFeedBackData.history_of_current_illness.length}}
                                            of {{max_message_length_hci}} characters left </p>
                                </div>
                                <div *ngIf="hci.invalid && (hci.dirty || hci.touched)" class="alert alert-danger">
                                    <div style="text-align: center;" *ngIf="hci.errors.required">
                                        History Of Current Illness
                                    </div>
                                </div>

                            </div>
                            <label class="boldnlabel">eGlobaldoctors Consultation Notes*</label>
                            <div class="ui-g-12">

                                <textarea class="format-lines msgtxtarea" pInputTextarea placeholder="Type here"
                                    [(ngModel)]="this.sendFeedBackData.consultation_notes" name="cn" #cn="ngModel"
                                    [required]="!isSuperAdmin()"></textarea>

                                <div style="text-align: center;">
                                    <p [style.color]="this.sendFeedBackData.consultation_notes.length-max_message_length_cn-1>0?'red':'green'"
                                        style="text-align: center;">
                                        {{(max_message_length_cn+1-this.sendFeedBackData.consultation_notes.length)
                                        <0?0:max_message_length_cn-this.sendFeedBackData.consultation_notes.length}} of
                                            {{max_message_length_cn}} characters left </p>
                                </div>
                                <div *ngIf="hci.invalid && (hci.dirty || hci.touched)" class="alert alert-danger">
                                    <div style="text-align: center;" *ngIf="hci.errors.required">
                                        Consultation Notes required
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                    <div class="ui-g" *ngIf="past_prescriptions.length && !isDietConsultation()">
                        <div class="ui-g-10">
                            <label class="boldnlabel">Past/Current Medications</label>
                        </div>
                        <button name="add" type="button"
                            class="button-glow ui-button-info ui-button-rounded doctofeedbckbtn" pButton
                            (click)="addSelected()">
                            <span class="patientvbtnspan icon-video_call"></span>
                            <span>Add Selected</span>
                        </button>
                        <div class="ui-g form-group ui-g-12">
                            <div class="ui-g-12">
                                <div class="table-responsive text-center justify-content-center">
                                    <p-table #dt1 [value]="past_prescriptions" dataKey="id" class="notranslate"
                                        styleClass="p-datatable-customers" [rows]="10" [paginator]="true"
                                        [showCurrentPageReport]="true" [scrollable]="true" scrollHeight="400px"
                                        [totalRecords]="past_prescriptions.length"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [rowsPerPageOptions]="[10,25,50]">

                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th pSortableColumn="Medication"><b>Medication</b>
                                                    <p-sortIcon field="Medication"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="times_per_day"><b>Times per day</b>
                                                    <p-sortIcon field="times_per_day"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dosage"><b>Dosage(in mg/ml)</b>
                                                    <p-sortIcon field="dosage"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="comments"><b>Comments</b>
                                                    <p-sortIcon field="comments"></p-sortIcon>
                                                </th>
                                                <th style="width: 100px;">Select</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-data>
                                            <tr>
                                                <td>{{data.medication_name}}</td>
                                                <td>{{data.times_per_day}}</td>
                                                <td>{{data.dosage}}</td>
                                                <td>{{data.comments}}</td>
                                                <td style="width: 100px;">
                                                    <p-checkbox [(ngModel)]="data.selected" [binary]="true"
                                                        inputId="binary">
                                                    </p-checkbox>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="10">No Data found.</td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="paginatorleft">
                                        </ng-template>
                                        <ng-template pTemplate="paginatorright">
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ng-container *ngIf="!isDietConsultation()">
                        <div class="ui-g">
                            <div class="ui-g form-group">
                                <label class="boldnlabel">Prescription </label>
                                <div class="ui-g-12">

                                    <div class="ui-g-12 ui-lg-6">
                                        <input id="Medication_Name" type="text" class="doctorfeedbackinput" pInputText
                                            [(ngModel)]="prescription.medication_name" placeholder="Medication Name"
                                            name="pmn" />
                                        <input id="timePerDay" type="number" class="doctorfeedbackinput" pInputText
                                            [(ngModel)]="prescription.times_per_day" placeholder="Times Per Day"
                                            name="tpd" />
                                    </div>
                                    <div class="ui-g-12 ui-lg-6">
                                        <input id="dosage" type="text" class="doctorfeedbackinput" pInputText
                                            [(ngModel)]="prescription.dosage" placeholder="Dosage(in mg/ml)"
                                            name="pd" />
                                        <input id="Medication_Name" type="number" class="doctorfeedbackinput" pInputText
                                            placeholder="Number of refills" [(ngModel)]="prescription.no_of_refills"
                                            min="0" name="nr" />
                                    </div>
                                    <div class="ui-g-12 ui-lg-6">
                                        <textarea pInputTextarea class="format-lines msgtxtarea" placeholder="Comments"
                                            [(ngModel)]="prescription.comments" name="pc"></textarea>
                                    </div>
                                    <div class="ui-g-12 ui-lg-6">
                                        <button name="add" type="button"
                                            class="button-glow ui-button-info ui-button-rounded doctofeedbckbtn" pButton
                                            (click)="add(0)" [disabled]="!((prescription.medication_name.length>0)
                                 &&(prescription.times_per_day>0)&&(prescription.dosage.length>0)
                                 &&(prescription.no_of_refills>0))">
                                            <span class="patientvbtnspan icon-video_call"></span>
                                            <span>Add +</span>
                                        </button>
                                    </div>

                                </div>



                            </div>
                        </div>

                        <div class="ui-g">

                            <div class="ui-g-12">
                                <div class="table-responsive text-center justify-content-center">
                                    <p-table #dt1 [value]="prescriptionlist" dataKey="id" class="notranslate"
                                        styleClass="p-datatable-customers" [rows]="10" [paginator]="true"
                                        [showCurrentPageReport]="true" [scrollable]="true" scrollHeight="400px"
                                        [totalRecords]="prescriptionlist.length"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [rowsPerPageOptions]="[10,25,50]" [globalFilterFields]="[
                                    'Sr.No',
                                    'Medication',
                                    'Dosage(in mg/ml)',
    
                                    'Times per day',
                                    'Number of Refills',
                                    'Comments']">

                                        <ng-template pTemplate="caption">
                                            <div class="table-header">
                                                <span class="p-input-icon-left table-search-span">

                                                    <input pInputText type="text" class="table-search"
                                                        (input)="dt1.filterGlobal($event.target.value, 'contains')"
                                                        placeholder="Search" />
                                                </span>
                                            </div>
                                        </ng-template>

                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th pSortableColumn="Medication"><b>Medication</b>
                                                    <p-sortIcon field="Medication"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="dosage"><b>Dosage(in mg/ml)</b>
                                                    <p-sortIcon field="dosage"></p-sortIcon>
                                                </th>

                                                <th pSortableColumn="times_per_day"><b>Times per day</b>
                                                    <p-sortIcon field="times_per_day"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="number_of_refills"><b>Number of Refills</b>
                                                    <p-sortIcon field="number_of_refills"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="comments"><b>Comments</b>
                                                    <p-sortIcon field="comments"></p-sortIcon>
                                                </th>
                                                <th style="width: 100px;">Edit</th>
                                                <th style="width: 100px;">Delete</th>


                                            </tr>


                                        </ng-template>
                                        <ng-template pTemplate="body" let-data>
                                            <tr>
                                                <td>{{data.medication_name}}</td>
                                                <td>{{data.dosage}}</td>
                                                <td>{{data.times_per_day}}</td>
                                                <td>{{data.no_of_refills}}</td>
                                                <td>{{data.comments}}</td>
                                                <td style="width: 100px;">
                                                    <button type="button" (click)="editPrescription(data.id,0)" pButton
                                                        icon="pi pi-pencil"></button>
                                                </td>
                                                <td style="width: 100px;">
                                                    <button type="button" (click)="deletePrescription(data.id)" pButton
                                                        icon="pi pi-trash"></button>
                                                </td>
                                            </tr>
                                        </ng-template>

                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="10">No Data found.</td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="paginatorleft">
                                        </ng-template>
                                        <ng-template pTemplate="paginatorright">
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="isDietConsultation()">
                        <div class="ui-g">
                            <div class="ui-g form-group">
                                <label class="boldnlabel">Nutritional Prescription </label>
                                <div class="ui-g-12">

                                    <div class="ui-g-12 ui-lg-6">
                                        <textarea id="advice" pInputTextarea class="format-lines msgtxtarea"
                                            placeholder="Advice" [(ngModel)]="this.prescription.advice"
                                            name="advice"></textarea>
                                    </div>
                                    <div class="ui-g-12 ui-lg-6">
                                        <textarea id="recommendations" pInputTextarea class="format-lines msgtxtarea"
                                            placeholder="Recommendations"
                                            [(ngModel)]="this.prescription.recommendations"
                                            name="recommendations"></textarea>
                                    </div>
                                    <div class="ui-g-12 ui-lg-6">
                                        <textarea id="comments" pInputTextarea class="format-lines msgtxtarea"
                                            placeholder="General Instructions" [(ngModel)]="this.prescription.comments"
                                            name="comments"></textarea>
                                    </div>
                                    <div class="ui-g-12 ui-lg-6">
                                        <button name="add" type="button"
                                            class="button-glow ui-button-info ui-button-rounded doctofeedbckbtn" pButton
                                            (click)="add(1)" [disabled]="!((this.prescription.comments.length>0) && (this.prescription.advice.length>0)
                                                     &&(this.prescription.recommendations.length>0))">
                                            <span class="patientvbtnspan icon-video_call"></span>
                                            <span>Add +</span>
                                        </button>
                                    </div>

                                </div>



                            </div>
                        </div>

                        <div class="ui-g">

                            <div class="ui-g-12">
                                <div class="table-responsive text-center justify-content-center">
                                    <p-table #dt1 [value]="prescriptionlist" dataKey="id"
                                        styleClass="p-datatable-customers" [rows]="10" [paginator]="true"
                                        [showCurrentPageReport]="true" [scrollable]="true" scrollHeight="400px"
                                        [totalRecords]="prescriptionlist.length"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        [rowsPerPageOptions]="[10,25,50]" [globalFilterFields]="[
                                                        'Sr.No',
                                                        'advice',
                                                        'recommendations',
                                                        'Comments']">

                                        <ng-template pTemplate="caption">
                                            <div class="table-header">
                                                <span class="p-input-icon-left table-search-span">

                                                    <input pInputText type="text" class="table-search"
                                                        (input)="dt1.filterGlobal($event.target.value, 'contains')"
                                                        placeholder="Search" />
                                                </span>
                                            </div>
                                        </ng-template>

                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th pSortableColumn="advice"><b>Advice</b>
                                                    <p-sortIcon field="advice"></p-sortIcon>
                                                </th>
                                                <th pSortableColumn="recommendations"><b>Recommendations</b>
                                                    <p-sortIcon field="recommendations"></p-sortIcon>
                                                </th>

                                                <th pSortableColumn="comments"><b>General Instructions</b>
                                                    <p-sortIcon field="comments"></p-sortIcon>
                                                </th>
                                                <th style="width: 100px;">Edit</th>
                                                <th style="width: 100px;">Delete</th>


                                            </tr>


                                        </ng-template>
                                        <ng-template pTemplate="body" let-data>
                                            <tr>
                                                <td>{{data.advice}}</td>
                                                <td>{{data.recommendations}}</td>
                                                <td>{{data.comments}}</td>
                                                <td style="width: 100px;">
                                                    <button type="button" (click)="editPrescription(data.id,1)" pButton
                                                        icon="pi pi-pencil"></button>
                                                </td>
                                                <td style="width: 100px;">
                                                    <button type="button" (click)="deletePrescription(data.id)" pButton
                                                        icon="pi pi-trash"></button>
                                                </td>
                                            </tr>
                                        </ng-template>

                                        <ng-template pTemplate="emptymessage">
                                            <tr>
                                                <td colspan="5">No Data found.</td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="paginatorleft">
                                        </ng-template>
                                        <ng-template pTemplate="paginatorright">
                                        </ng-template>
                                    </p-table>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <div class="ui-g consultationclose" *ngIf="!isDietConsultation() && this.is_primary_provider && !this.is_uk_country">
                        <div class="ui-g-12">
                            <span class="section-heading">Refer to Nutrition Coach?
                            </span>
                        </div>
                        <div class="ui-md-8">
                            <span class="doctorfradio">
                                <p-radioButton name="case11" label="Yes" [value]=1
                                    [(ngModel)]="this.sendFeedBackData.referred_to_specialty_id"
                                    [required]="!isSuperAdmin()">
                                </p-radioButton>
                            </span>
                            <span class="doctorfradio">
                                <p-radioButton name="case22" label="No" [value]=0
                                    [(ngModel)]="this.sendFeedBackData.referred_to_specialty_id"
                                    [required]="!isSuperAdmin()">
                                </p-radioButton>
                            </span>
                        </div>
                    </div>

                    <div class="ui-g consultationclose">
                        <div class="ui-g-12">
                            <span class="section-heading ">Do you want to close this case?
                            </span>
                        </div>
                        <div class="ui-md-8">
                            <span class="doctorfradio">
                                <p-radioButton name="case1" label="Yes" [value]="true"
                                    [(ngModel)]="sendFeedBackData.is_closed" required>
                                </p-radioButton>
                            </span>
                            <span class="doctorfradio">
                                <p-radioButton name="case2" label="No" [value]="false"
                                    [(ngModel)]="sendFeedBackData.is_closed" required>
                                </p-radioButton>
                            </span>
                        </div>
                    </div>

                    <ng-container *ngIf="isDietConsultation() && this.consultation_data.consultations_left>0">
                        <div class="ui-g">
                            <div class="ui-g form-group">
                                <div class="ui-g-12 ">
                                    <div class="ui-g-12">
                                        <label for="Doctor Referred Timings">Next Consultation Schedules
                                            <span class="req" style="color: crimson">*</span></label>
                                    </div>
                                    <div class="ui-g-12">
                                        <p-dropdown id="DoctorSchedule" placeholder="Select a Doctor Schedule"
                                            [options]="schedules" [style]="{width: '600px'}"
                                            [(ngModel)]="this.sendFeedBackData.slot_id" [filter]="true"
                                            [required]="!isSuperAdmin()">
                                        </p-dropdown>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </ng-container>


                    <div style="text-align: center;">
                        <div *ngIf="sendFeedBackData.is_closed && !sendFeedBackData.close_otp_checkbox">
                            <p class="section-heading ">Password</p>
                            <input id="caseCloseYes" [type]="isPassword?'password':'text'" class="doctorfeedbackinput"
                                pInputText [(ngModel)]="sendFeedBackData.sign" name="pwd"
                                placeholder="Enter your Password" [required]="!sendFeedBackData.close_otp_checkbox" />
                            <span toggle="#password-field" class="fa fa-fw field_icon"
                                [ngClass]="{'fa-eye-slash': !isPassword,'fa-eye': isPassword}" style="color:black"
                                (click)="this.isPassword = !this.isPassword"></span>
                        </div>

                        <div class="ui-g consultationclose" *ngIf="sendFeedBackData.is_closed">
                            <div class="form-group form-check">
                                <input type="checkbox" [(ngModel)]="sendFeedBackData.close_otp_checkbox"
                                    [required]="!sendFeedBackData.sign" (change)="otpVerifySubmit()"
                                    class="form-check-input register-checkbox-fix" id="otp_close" name="otp_close">
                                <label class="section-heading" for="otp_close">
                                    Close case using OTP instead of password?
                                </label>
                            </div>
                        </div>
                        <app-error-messages [api_result]="this.data1.otp_api_result">
                        </app-error-messages>


                        <div class="form-div" *ngIf="this.show_otp && sendFeedBackData.close_otp_checkbox">
                            <div class="ui-g" style="justify-content: center !important; ">
                                <p>We have sent you an otp on your registered mobile number and email.</p>
                                <otp-input class="ui-g-12" [isPrimeNg]="true" [otp_data]="this.data1"
                                    (otp_resend)="otp_resend()">
                                </otp-input>
                            </div>
                            <!-- <div class="text-center">
                                <button pButton class="submitbutton1 messagesbtn" (click)="getOTPdata()"
                                    label="Get OTP"></button>
                            </div> -->
                        </div>
                        <div *ngIf="sendFeedBackData.is_closed==false">
                            <p class="section-heading">Reason</p>
                            <textarea class="format-lines msgtxtarea" pInputTextarea placeholder="Reason"
                                [(ngModel)]="sendFeedBackData.issues" name="issue" required></textarea>
                        </div>
                    </div>
                </div>
                <app-loading class="col-12 text-center" *ngIf="this.data1.otp_api_result.Posting" type="SMALL_LOADER"></app-loading>
                <div class="text-center">
                    <button pButton [disabled]="!feedBackForm.valid" class="submitbutton1 messagesbtn"
                        label="Submit"></button>
                    <!-- <button pButton type="button" class="submitbutton1 messagesbtn" label="Cancel" (click)="closeFeedBackSection()"  ></button> -->
                </div>
                <app-loading *ngIf="this.post_api_result.Posting" type="POSTING_DATA"></app-loading>
                <app-error-messages style="text-align: center;" [api_result]="this.post_api_result">
                </app-error-messages>
            </form>
        </div>
    </div>
</div>


<app-error-messages [api_result]="this.get_api_result"></app-error-messages>